import { ResponseCommon } from "../../model/responseCommon";
import { Sgke122aResponseSearchresultList } from "./sgke122a-response-searchresult-list";

export class Sgke122aResponse {
    /** レスポンス共通エリア */
    responseCommon: ResponseCommon;
    /** 検索結果リスト */
    searchresultList: Array<Sgke122aResponseSearchresultList>;
    /** 確認済過不足累計 */
    confirmzumiKafusokuRuikei: number;
    /** 表示過不足額合計 */
    hyojiBalanceSum: number;
}
